import { render, staticRenderFns } from "./ItemListView.vue?vue&type=template&id=63ff22f0"
import script from "./ItemListView.vue?vue&type=script&lang=js"
export * from "./ItemListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63ff22f0')) {
      api.createRecord('63ff22f0', component.options)
    } else {
      api.reload('63ff22f0', component.options)
    }
    module.hot.accept("./ItemListView.vue?vue&type=template&id=63ff22f0", function () {
      api.rerender('63ff22f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/item/ItemListView.vue"
export default component.exports